<div class="table-chart" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px"
	[style]="{'--outline-color': tableOutlineColor,'--bar-color': barColor}">

	<ng-container *ngIf="tableData">
		<table border="0" cellspacing="0" cellpadding="0">
			<thead>
				<tr>
					<ng-container *ngFor="let title of tableData?.graph?.labels; let rowHeaderIndex = index;">
						<th>
							<div class="th-item" fxLayout="row" fxLayoutAlign="space-between center"
								[ngClass]="{'cursor-pointer hover-effect': filterIndexArr.includes(rowHeaderIndex)}">
								<p>{{title}}</p>
<ng-container *ngIf="filterIndexArr.includes(rowHeaderIndex)">
								<ng-container *ngFor="let filter of filterPositions; let filterIndex = index;">
									<ng-container *ngIf="filter?.index === rowHeaderIndex && filter?.sorting">
										
								<div  fxLayout="column" fxLayoutAlign="start stretch"(click)="getFilter(filter, {index: filterIndex, filterType: 'sort'})">
											
									<mat-icon class="filter-icon" [ngClass]="{'disabled': filter?.descending}">arrow_drop_up</mat-icon>
									<mat-icon class="filter-icon" [ngClass]="{'disabled': filter?.ascending}">arrow_drop_down</mat-icon>
									</div>
									</ng-container>
								</ng-container>
							</ng-container>
							</div>

						</th>
					</ng-container>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let dataset of tableData?.graph?.datasets; let rowIndex = index;">
					<tr>
						<ng-container *ngFor="let data of dataset?.data; let dataIndex = index;">
							<ng-container *ngIf="!tableData?.graph?.barPosition?.includes(dataIndex)">
								<td>
									<div class="td-item">
										<span (click)="detail(data, dataset, {type: 'content', rowIndex: rowIndex, dataIndex: dataIndex})"
											[ngClass]="{'cursor-pointer hover-effect': detailIndexArr.includes(dataIndex)}">{{ data }}</span>
									</div>
								</td>
							</ng-container>
							<ng-container *ngIf="tableData?.graph?.barPosition && tableData?.graph?.barPosition?.includes(dataIndex)">
								<td>
									<div class="td-item bar"
										(click)="detail(data, dataset, {type: 'bar', rowIndex: rowIndex, dataIndex: dataIndex})"
										[ngClass]="{'cursor-pointer': indexArr.includes(dataIndex)}">
										<mat-progress-bar mode="determinate" [value]="data" class="table-progress-bar"></mat-progress-bar>
									</div>
								</td>
							</ng-container>

						</ng-container>
					</tr>
				</ng-container>
			</tbody>
		</table>
	</ng-container>
</div>
